module.exports = __webpack_public_path__ + "static/media/home-slide-6.da32cb76.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/MainImage/home-slide-6.jpg
// module id = 341
// module chunks = 0